import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPut } from "../client";

/**
 * Hook to get notifications
 */
export function useNotifications(enabled = true, onError?: (errorCode: string) => void) {
	return useQuery<any>({
		queryKey: ["notification"],
		queryFn: () => apiGet<any>("/notification"),
		enabled,
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});
}

/**
 * Hook to mark notifications as read
 */
export function useNotificationsRead(onError?: (errorCode: string) => void) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (body: any) => apiPut("/notification/read", body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["notification"] });
		},
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});
}
